var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.627,
    height: 16.971,
    viewBox: "0 0 22.627 16.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(-1742.575 -178.015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2736",
    "data-name": "Rectangle 2736",
    width: 4,
    height: 12,
    transform: "translate(1742.575 186.5) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2737",
    "data-name": "Rectangle 2737",
    width: 4,
    height: 20,
    transform: "translate(1762.374 178.015) rotate(45)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnable);
export default __webpack_public_path__ + "static/media/Enable.b80f038e70d703904ae4f111a485e558.svg";
export { ForwardRef as ReactComponent };